import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportButton({
  dataTestId,
  isCustomer,
  onClick
}) {
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isCustomer,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": dataTestId,
      disabled: !isCustomer,
      marginInlineStart: "200",
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.report"
      })
    })
  });
}